// About Us page JS entry
import "../scss/about.scss";

document.addEventListener("DOMContentLoaded", () => {
	// Accordion interactivity for FAQ items
	const faqItems = document.querySelectorAll(".cyprus-about-faq__item");

	faqItems.forEach((item) => {
		const summary = item.querySelector(".cyprus-about-faq__question");
		if (!summary) return;

		summary.addEventListener("click", (e) => {
			if (!item.hasAttribute("open")) {
				faqItems.forEach((other) => {
					if (other !== item && other.hasAttribute("open")) {
						other.removeAttribute("open");
					}
				});
			}
		});
	});
});
